export const status = [
  {text: 'Черновик', value: 'DRAFT'},
  {text: 'Опубликовано', value: 'PUBLISHED'},
  {text: 'Активно', value: 'ACTIVATED'},
  {text: 'Голосование завершено', value: 'VOTE_ENDED'},
  {text: 'Зафиксированы результаты', value: 'RESULTS_RECORDED'}
]

export const statusAsString = function(type) {
  return status.find(it => it.value === type).text
}
